import { AxiosResponse } from "axios";
import api from "../api/api";
import { DetalheItem, ItemCarrinho, ItemDestaque } from "../pages/Cardapio/public/CatalogoPage";

export const catalogoService = {
    registerCatalogo: async (
        data: FormData,
        token?: string
    ) : Promise<boolean> => {
        try {
            const response = await api.post(
                `/catalogo`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error: any) {
            console.error(error);

            const resposta = error.response?.data;
        
            // Lista de erros de validação
            if (Array.isArray(resposta)) {
                resposta.forEach((erro: { campo: string; mensagem: string }) => {
                    alert(erro.mensagem);
                });
        
                return false;
            }
        
            // Erro padrão da API
            if (resposta?.message) {
                alert(resposta.message);
                return false;
            }
        
            // Sem resposta (erro de rede, timeout, etc.)
            if (!error.response) {
                alert("Não foi possível conectar ao servidor.");
                return false;
            }
        
            // Fallback
            alert("Ocorreu um erro ao cadastrar o catálogo.");
            return false;
        }
    },

    deleteCatalogo: async (
        idEmpresa: number,
        idCatalogo: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.delete(
                `/catalogo/admin/${idCatalogo}?idEmpresa=${idEmpresa}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status === 200;
        } catch (error: any) {
            alert(error?.response?.data?.message ?? "Erro ao excluir item do catálogo.");
            return false;
        }
    },

    patchCatalogo: async (
        idCatalogo: number,
        data: FormData,
        token?: string
    ) : Promise<boolean> => {
        try {
            const response = await api.patch(
                `/catalogo/admin/${idCatalogo}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error: any) {
            console.error(error);

            const resposta = error.response?.data;
        
            // Lista de erros de validação
            if (Array.isArray(resposta)) {
                resposta.forEach((erro: { campo: string; mensagem: string }) => {
                    alert(erro.mensagem);
                });
        
                return false;
            }
        
            // Erro padrão da API
            if (resposta?.message) {
                alert(resposta.message);
                return false;
            }
        
            // Sem resposta (erro de rede, timeout, etc.)
            if (!error.response) {
                alert("Não foi possível conectar ao servidor.");
                return false;
            }
        
            // Fallback
            alert("Ocorreu um erro ao editar o catálogo.");
            return false;
        }
    },

    /* CATALOGO */
    registerCategoria: async (
        data: FormData,
        idEmpresa: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.post(
                `/catalogo/admin/empresa/${idEmpresa}/categoria`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error) {
            return false;
        }
    },

    getCatalogo: async (idEmpresa: number, categoria?: string) => {
        const response = await api.get(`/catalogo/public`, {
            params: {
                idEmpresa,
                categoria
            }
        });
        return response.data;
    },

    getCatalogoAdmin: async (idEmpresa: number, token: string, categoria?: string) => {
        const response = await api.get(`/catalogo/admin`, {
            params: {
                idEmpresa,
                categoria
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    },

    getCategorias: async (idEmpresa: number) => {
        const response = await api.get(`/catalogo/public/categorias`, {
            params: {
                idEmpresa
            }
        });
        return response.data;
    },

    getCategoriasAdmin: async (idEmpresa: number, token: string) => {
        const response = await api.get(`/catalogo/admin/categorias`, {
            params: {
                idEmpresa
            }, 
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    },

    getMaisPedidos: async (idEmpresa: number) => {
        const response = await api.get(`/catalogo/public/mais-pedidos`, {
            params: {
                idEmpresa
            }
        });
        return response.data;
    },

    /* COMPLEMENTOS */
    registerComplemento: async (
        data: FormData,
        idCategoria: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.post(
                `/catalogo/admin/categoria/${idCategoria}/complemento`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error) {
            return false;
        }
    },

    getComplementosAdmin: async (idEmpresa: number, idCategoria: number, token: string) => {
        const response = await api.get(`/catalogo/admin/categoria/${idCategoria}/complementos`, {
            params: {
                idEmpresa
            }, 
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    },

    patchComplemento: async (
        data: FormData,
        idCategoria: number,
        idComplemento: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.patch(
                `/catalogo/admin/categoria/${idCategoria}/complemento/${idComplemento}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error) {
            return false;
        }
    },

    deleteComplemento: async (
        idEmpresa: number,
        idCategoria: number,
        idComplemento: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.delete(
                `/catalogo/admin/empresa/${idEmpresa}/categoria/${idCategoria}/complemento/${idComplemento}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status === 200;
        } catch (error: any) {
            alert(error?.response?.data?.message ?? "Erro ao excluir complemento.");
            return false;
        }
    },

    /* OPCOES */

    registerOpcao: async (
        data: FormData,
        idCategoria: number,
        token?: string
    ) : Promise<boolean> => {
        try {
            const response = await api.post(
                `/catalogo/admin/categoria/${idCategoria}/opcao`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error) {
            return false;
        }
    },

    patchOpcao: async (
        data: FormData,
        idCategoria: number,
        idOpcao: number,
        token?: string
    ) : Promise<boolean> => {
        try {
            const response = await api.patch(
                `/catalogo/admin/categoria/${idCategoria}/opcao/${idOpcao}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error) {
            return false;
        }
    },

    deleteOpcao: async (
        idEmpresa: number,
        idCategoria: number,
        idOpcao: number,
        token?: string
    ): Promise<boolean> => {
        try {
            const response = await api.delete(
                `/catalogo/admin/empresa/${idEmpresa}/categoria/${idCategoria}/opcao/${idOpcao}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
    
            return response.status == 200;
        } catch (error: any) {
            alert(error?.response?.data?.message ?? "Erro ao excluir opção.");
            return false;
        }
    },

    getOpcoesPublic: async (idEmpresa: number, idCategoria: number) => {
        const response = await api.get(`/catalogo/public/categoria/${idCategoria}/opcoes`, {
            params: {
                idEmpresa
            }
        });
        return response.data;
    },  

    getOpcoesAdmin: async (idEmpresa: number, idCategoria: number, token: string) => {
        const response = await api.get(`/catalogo/admin/categoria/${idCategoria}/opcoes`, {
            params: {
                idEmpresa
            }, 
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    },    

    mountItemCarrinho: (itens: any, novoItem: DetalheItem) => {
        // 1. Verifica se o item já existe no carrinho
        const itemExiste = itens.find((i: any) => i.item.id === novoItem.id);

        if (itemExiste) {
            // 2. Retorna um NOVO array com o item atualizado
            return itens.map((i: any) =>
                i.item.id === novoItem.id
                    ? { ...i, qtd: i.qtd + 1 }
                    : i
            );
        }

        // 3. Se não existe, adiciona o novo item
        return [
            ...itens,
            {
                item: novoItem,
                qtd: 1,
                vlrUnitario: novoItem.subtotal,
                opcao: novoItem.opcao,
                complementos: novoItem.complementos ?? [],
                complementosEspecificos: novoItem.complementosEspecificos ?? [],
                midias: novoItem.midias,
                observacao: ""
            }
        ];
    }
};